export enum BorderType {
  SOLID = "solid",
  DASHED = "dashed",
  DOTTED = "dotted"
}
